//import { AdditionalCostService } from './../../pages/Purchases/components/AdditionalCost/addtionalCost.service';
import { VoucherDateComponent } from './voucher-date.component';
import { TrnMainVoucherEntryComponent } from './trnmain-voucher-entry.component';
import { TrnTranVoucherEntryComponent } from './trntran-voucher-entry.component';
import { NgModule } from '@angular/core';
//import { TrnMainPurchaseComponent } from './trnmain-purchase.component';
import { ProductInsertComponent } from './ProductInsert';
import { TrnMainBranchComponent } from './trnmain-branch.component';
import { InvoiceComponent } from '../Invoice/invoice.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgaModule } from '../../theme/nga.module';
//import { AutoCompleteModule } from "primeng/components/autocomplete/autocomplete";
//import { NguiAutoCompleteModule } from "@ngui/auto-complete/dist";
// import { TrnMainNoteItemBaseComponent } from './trnmain-note-itembase-entry.component';
import { FocusDirective } from './focus.directive';
import { SubFocusDirective } from './sub-ledger-focus.directive';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SalesModeComponent } from './sales-mode.component';
import { VATNoEntry } from './VATnoEntry.component';
import { CreditNoteModeComponent } from './creditnotemodes';
import { PurchasePrintComponent } from './../Invoice/purchasePrint.component';
import { InvoicePrintComponent } from './../Invoice/invoicePrint.component';
import { GenericPopupGridModule } from '../Popups/generic-grid/generic-popup-grid.module';
import { MatFormFieldModule } from '@angular/material/form-field';
@NgModule({
  imports: [
    ModalModule.forRoot(),
    GenericPopupGridModule.forRoot(),
    NgaModule,
    MatFormFieldModule,
  ],
  declarations: [
    //TrnMainPurchaseComponent,
    VoucherDateComponent,
    ProductInsertComponent,
    TrnMainBranchComponent,
    FocusDirective,
    InvoiceComponent,
    TrnTranVoucherEntryComponent,
    TrnMainVoucherEntryComponent,
    // TrnMainNoteItemBaseComponent,
    SubFocusDirective,
    VATNoEntry,
    SalesModeComponent,
    CreditNoteModeComponent,
    PurchasePrintComponent,
    InvoicePrintComponent,
  ],
  exports: [
    //TrnMainPurchaseComponent,
    VoucherDateComponent,
    ProductInsertComponent,
    TrnMainBranchComponent,
    InvoiceComponent,
    TrnTranVoucherEntryComponent,
    TrnMainVoucherEntryComponent,
    // TrnMainNoteItemBaseComponent,
    FocusDirective,
    SubFocusDirective,
    SalesModeComponent,
    VATNoEntry,
    CreditNoteModeComponent,
    PurchasePrintComponent,
    InvoicePrintComponent,
  ],
  providers: [],
})
export class TransactionModule {}
